import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { SeoPageService } from '@seo/feature';
import { Crumb } from '@shared/models';
import { DeviceService } from '@shared/services';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'sd-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterLink, SdvorIconComponent],
})
export class BreadcrumbsComponent implements OnInit {
  breadcrumbs$: Observable<Crumb[] | null>;
  loading$: Observable<boolean>;

  constructor(
    private seoPageService: SeoPageService,
    protected deviceService: DeviceService,
  ) {}

  ngOnInit(): void {
    this.breadcrumbs$ = this.seoPageService.getSeoPage().pipe(
      map((seo) => {
        if (!seo || !seo.breadcrumbs) {
          return null;
        }

        return seo.breadcrumbs;
      }),
    );

    this.loading$ = this.seoPageService.isLoading();
  }
}
